import { Check, Copy, Info } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { copyToClipboard } from "@/lib/clipboard";
import { DEFAULT_INSTALL_STEPS } from "@/lib/skills/constants";

export function InstallBlock({
  install,
  notes,
  steps,
}: {
  install: string;
  notes?: string;
  steps?: string[];
}) {
  const resolvedSteps = steps && steps.length > 0 ? steps : DEFAULT_INSTALL_STEPS;
  const [copied, setCopied] = useState(false);
  async function copy() {
    const ok = await copyToClipboard(install);
    if (!ok) {
      toast.error("Couldn't copy — select the command and copy it manually");
      return;
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1600);
  }
  return (
    <section className="flex flex-col gap-4">
      <div className="relative rounded-[9px] bg-navy px-4 py-3.5 font-mono text-sm text-white/90">
        <span className="select-none pr-2 text-fg-link">$</span>
        {install}
        <button
          type="button"
          onClick={() => void copy()}
          aria-label="Copy install command"
          className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-md bg-white/10 px-2.5 py-1 text-xs font-medium text-white hover:bg-white/20"
        >
          {copied ? <Check className="size-3.5" /> : <Copy className="size-3.5" />}
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <ol className="flex flex-col gap-2 text-sm text-fg-2">
        {resolvedSteps.map((step, i) => (
          <li key={step} className="flex gap-2">
            <Step n={i + 1} />
            {step}
          </li>
        ))}
      </ol>
      {notes ? (
        <div className="flex gap-2 rounded-[9px] border border-border-1 bg-bg-2 px-4 py-3 text-sm text-fg-2">
          <Info className="size-4 shrink-0 text-fg-link" />
          <div>
            <b className="text-fg-1">Custom install notes — </b>
            {notes}
          </div>
        </div>
      ) : null}
    </section>
  );
}

function Step({ n }: { n: number }) {
  return (
    <span className="grid size-5 shrink-0 place-items-center rounded-full bg-bg-3 text-xs font-semibold text-fg-2">
      {n}
    </span>
  );
}
